import {LifecycleAction} from "../../../../../gd/const/lifecycle"
import TasksViewManager from "../../../../../gd-modules/tasks-view/core/manager"
import FieldProto from "../../../field-proto"



/**
 * Triggers a view update in TasksViewManager for changes affecting the passed field.
 * - Calls lifecycle stages: PROCESS_DATA, RENDER, and (optionally) GROUP.
 *
 * @param manager - view manager
 * @param field - field for which the update is triggered
 */
export default function FieldProto_updateView(manager: TasksViewManager, field: FieldProto) {

    const FieldIdsMap: Record<ID, ID> = {
        [gd.fields.itemModel.calculatedStoryPoints.fieldId]: gd.fields.task.storyPoints.fieldId
    }

    const lifecycleActions = [
        LifecycleAction.SORT,
        LifecycleAction.PROCESS_DATA,
        LifecycleAction.RENDER
    ]

    // Use mapped field id if exists, otherwise use field's own id.
    let fieldId = FieldIdsMap[field.fieldId] || field.fieldId

    // If the field is included in current grouping, also trigger GROUP phase
    if (manager.groupBy?.groupingFieldsIds.includes(fieldId)) {
        lifecycleActions.push(LifecycleAction.GROUP)
    }

    manager.update(lifecycleActions)
}